/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    instanceOfRtSystemManufacturer,
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';

/**
 * @type EquipmentTypeCatalogDtoManufacturer
 * 
 * @export
 */
export type EquipmentTypeCatalogDtoManufacturer = RtSystemManufacturer;


export function EquipmentTypeCatalogDtoManufacturerFromJSON(json: any): EquipmentTypeCatalogDtoManufacturer {
    return EquipmentTypeCatalogDtoManufacturerFromJSONTyped(json, false);
}

export function EquipmentTypeCatalogDtoManufacturerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentTypeCatalogDtoManufacturer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...RtSystemManufacturerFromJSONTyped(json, true) };
    return  RtSystemManufacturerFromJSONTyped(json, true);
}

export function EquipmentTypeCatalogDtoManufacturerToJSON(value?: EquipmentTypeCatalogDtoManufacturer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfRtSystemManufacturer(value)) {
        return RtSystemManufacturerToJSON(value as RtSystemManufacturer);
    }

    return {};
}

/**
 * Check if a given object implements the EquipmentTypeCatalogDtoManufacturer interface.
 */
export function instanceOfEquipmentTypeCatalogDtoManufacturer(value: any): value is EquipmentTypeCatalogDtoManufacturer {
    if (instanceOfRtSystemManufacturer(value)) return true;
    return false;
}

